import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import {Body, H2, H3, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {PaymentCurrencyType, Wallet} from "@irati/types"
import {CalendarBody, CalendarHeader, CalendarWrapper} from "@irati-web/home/src/components/NewHomePage/ExpiryInformationBanner/styled"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Badge from "@irati/ui/src/Badge"
import {ExpiringSoon} from "../styled"
import {useFlexiPointsWalletExpired} from "../../../hooks/expiry"

interface Props {
  wallet: Wallet
  showModal: boolean
  onClick: () => void
}

const ExpiryModal: FC<Props> = ({onClick, showModal, wallet}) => {
  const {colors} = useTheme()
  const {expiry} = useFlexiPointsWalletExpired(wallet.uuid)

  if (!expiry.hasExpiry) return null

  return (
    <GenericModal hideActions onHide={onClick} show={showModal}>
      <Flex direction="column" gap={4}>
        <H2>
          <FormattedMessage id="wallet.reward.admin.expiryModal.title" />
        </H2>

        <Body>
          <FormattedMessage id="wallet.reward.admin.expiryModal.body" />
        </Body>

        <Card small bgColor={colors.greys.lightest}>
          <Flex gap={3}>
            <ExpiringSoon justifyContent="center" noBorder>
              <div>
                <Label color={colors.utility.contrast} marginRight={1}>
                  <FormattedMessage id="wallet.availableBalance.info.expire" />
                </Label>
                <Badge padding={[0.5, 1]} weight="light" bgColor={colors.greys.graphGrey} color={colors.utility.contrast}>
                  {expiry.date}
                </Badge>
                <Flex justifyContent="center">
                  <H3>
                    <FormattedCurrency currency={PaymentCurrencyType.Rp} value={expiry.amount} />
                  </H3>
                </Flex>
              </div>
            </ExpiringSoon>

            <CalendarWrapper flex="1">
              <Card flush>
                <CalendarHeader>
                  <FormattedMessage id="platform.homepage.expiryBanner.calendar.header" />
                </CalendarHeader>
                <CalendarBody>{expiry.daysLeft}</CalendarBody>
              </Card>
            </CalendarWrapper>
          </Flex>
        </Card>

        <ButtonRouterLink id="expiryModalDistributeRewardsButton" to="/flexi-assign/recipients">
          <FormattedMessage id="wallet.reward.admin.btn.distribute" />
        </ButtonRouterLink>
      </Flex>
    </GenericModal>
  )
}

export default ExpiryModal
